module.exports = __webpack_public_path__ + "img/error.62318c12.gif";